const baseInfo = {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {}
}

export default baseInfo
